export default __webpack_public_path__ + "static/sockexplorer-48c2e96c4fbd0134b7c69e47d573ef25.jpg";